import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=28451de2&scoped=true"
import script from "./OrderDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDrawer.vue?vue&type=style&index=0&id=28451de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28451de2",
  null
  
)

export default component.exports